import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiSettingFormModule } from '@components/ui-forms/ui-setting-form.module';
import { SharedModule } from '@modules/shared.module';
import { MailModalComponent } from '@pages/settings/mail.modal';
import { SettingsPageComponent } from '@pages/settings/settings.page';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

const MODALS = [
    MailModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiSettingFormModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
    ],
    declarations: [
        ...MODALS,
        SettingsPageComponent,
    ],
    exports: [
        ...MODALS,
        SettingsPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class SettingsModule { }
